'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  margin-left: ', ';\n  right: 0;\n  left: 0;\n  top: ', ';\n'], ['\n  position: relative;\n  margin-left: ', ';\n  right: 0;\n  left: 0;\n  top: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _sizes = require('HubStyleTokens/sizes');

var _colors = require('HubStyleTokens/colors');

var _Use = require('./utils/Use');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CLOSE_BUTTON_USE_COLOR_MAP = {
  default: _colors.EERIE,
  shepherd: _colors.OLAF,
  longform: _colors.CALYPSO,
  tooltip: _colors.OLAF,
  'tooltip-danger': _colors.OLAF,
  unstyled: _colors.EERIE
};

var StyledCloseButton = (0, _styledComponents2.default)(_UICloseButton2.default).withConfig({
  displayName: 'UIPopoverCloseButton__StyledCloseButton'
})(_templateObject, function (_ref) {
  var size = _ref.size;
  return size === 'sm' || size === 'small' ? null : parseInt(_sizes.MEDIUM_CLOSE_BUTTON_SIZE, 10) + 4 + 'px';
}, function (_ref2) {
  var size = _ref2.size;
  return (size === 'sm' || size === 'small' ? 0 : parseInt(_sizes.POPOVER_PADDING_X, 10) - parseInt(_sizes.POPOVER_PADDING_Y, 10)) + 'px';
});

var UIPopoverCloseButton = _react2.default.createClass({
  displayName: 'UIPopoverCloseButton',

  propTypes: {
    color: _react.PropTypes.string,

    size: _UICloseButton2.default.propTypes.size,
    popoverUse: _react.PropTypes.oneOf(Object.keys(_Use.USE_CLASSES))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: 'md',
      popoverUse: 'default'
    };
  },
  render: function render() {
    var _props = this.props,
        popoverUse = _props.popoverUse,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['popoverUse', 'size']);

    var computedColor = CLOSE_BUTTON_USE_COLOR_MAP[popoverUse];
    var computedSize = popoverUse === 'longform' ? 'sm' : size;
    return _react2.default.createElement(StyledCloseButton, _extends({ color: computedColor, size: computedSize }, rest));
  }
});

exports.default = UIPopoverCloseButton;
module.exports = exports['default'];